import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import '../styles/font/font.css';

/* Layout */
import TheMain from '@/layouts/TheMain.vue'

/* User */
import Login from '@/views/LoginView.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue';
import Admin from '@/components/user/AdminForm.vue';
import Guest from '@/components/user/GuestForm.vue';
import PasswordReset from '@/views/user/PasswordReset.vue';
import UserView from '@/views/user/UserInfoView.vue';
import UserCreate from '@/components/user/UserCreate.vue';

/* VOD */
import Template from '@/views/template/TemplateView.vue';
import AssetModify from '@/views/Asset/Asset-Modify.vue';
import UploadOption from '@/views/user/UploadOptionView.vue';
import PlayerOption from '@/views/user/PlayerOptionView.vue';
import EncodingList from '@/views/encoding/EncodingListView.vue';
import EncodingCreate from '@/components/encoding/EncodingCreate.vue';
import PlayList from '@/views/playlist/PlayListView.vue';
import SocialUpload from '@/components/socialupload/SocialUploadForm.vue';
import socialConnected from '@/views/social/SocialConnectedView.vue';
import GoogleCallback from '@/components/socialupload/GoogleCallback.vue';

/* HLS live */
import WowzaLivestreamCreate from '@/views/wowzalivestream/WowzaLivestreamCreate.vue';
import WowzaLivestreamView from '@/components/livestream/WowzaLivestreamViewForm.vue';
import WowzaLivePullstreamView from '@/components/livestream/WowzaLivePullstreamViewForm.vue';
import WowzaLivestreamRecording from '@/views/wowzalivestream/WowzaLivestreamRecording.vue';

/* WebRTC */
import WebRtcLivestreamCreate from '@/views/webrtclivestream/WebRtcLivestreamCreate.vue';
import WebRtcLivestreamRecording from '@/views/webrtclivestream/WebRtcLivestreamRecording.vue';
import WebRtcLivestreamView from '@/components/webrtc/WebRtcLivestreamViewForm.vue';
import WebRtcLivePullstreamView from '@/components/webrtc/WebRtcLivePullstreamViewForm.vue';

/* player */
import Player from '@/components/player/player.vue';
import Play from '@/components/player/Play.vue';
// import Playertest from '@/components/player/Playtest.vue';
// import Playertest3 from '@/components/player/Playtest3.vue';
// import Playertest4 from '@/components/player/Playtest4.vue';
// import PlayerStyle from '@/components/player/Player-style.vue';
import webrtcPlayer from '@/components/player/webrtc_player.vue';
import securePlayer from '@/components/player/webrtc_secure_player.vue';
import streamPlayer from '@/components/player/webrtc_secure2_player.vue';
// import streamPlayer from '@/components/player/hls_player.vue';

/* Statistics */
import Statistics from '@/views/statistics/StatisticsView.vue';
import VodStatistics from '@/views/statistics/VodStatisticsView.vue';
import LiveStatistics from '@/views/statistics/LiveStatisticsView.vue';
import WebRtcStatistics from '@/views/statistics/WebRtcStatisticsView.vue';
import ServiceStatistics from '@/views/statistics/ServiceStatisticsView.vue';

/* CDN */
import CdnList from '@/views/cdn/CdnListView.vue';
import CdnCreate from '@/components/cdn/CdnCreate.vue';
import CdnInfo from '@/components/cdn/CdnInfo.vue';

/* Cert */
import CertList from '@/views/cert/CertListView.vue';
import CertImport from '@/components/cert/CertImport.vue';
import CertTag from '@/components/cert/CertTag.vue';

/* wowza */
import WowzaList from '@/views/wowza/WowzaListView.vue';
import WowzaCreate from '@/components/wowza/WowzaCreate.vue';

/* ERROR PAGE */
import PAGE404 from '@/pages/404.vue';
import PAGEMedia from '@/pages/MediaError.vue';
import ForbiddenPage from '@/pages/Forbidden.vue';


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: TheMain,
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
        meta: { public: true },
      },
      {
        path: '/asset',
        name: 'asset',
        component: () => import('../views/Asset/Asset.vue'),
      },
      {
        path: '/asset-modify',
        name: 'asset-modify',
        component: AssetModify,
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
      },
      {
        path: 'playlist',
        name: 'playlist',
        component: PlayList,
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: Statistics,
      },
      {
        path: '/service-statistics',
        name: 'serviceStatistics',
        component: ServiceStatistics,
      },
      {
        path: '/admin/user',
        name: 'user',
        component: UserView,
        
      },
      // {
      //   path: '/admin/user/:username',
      //   name: 'user-details',
      //   component: Guest,
      //   beforeEnter: (to, from, next) => {
      //     // store.dispatch('user/adminCheck').then(() => {
      //     const loggedInUser = store.getters['user/username'];
      //     //console.log('log', loggedInUser);
      //     if (loggedInUser !== 'kcinfra' && loggedInUser === to.params.username) {
      //       next();
      //     } else {
      //       //next('/');
      //     }
      //     // })
      //   },
      // },
      {
        path: '/admin/user_details/:userId',
        name: 'admin-user-details',
        component: Admin,
        beforeEnter: (to, from, next) => {
          store.dispatch('user/adminCheck').then(() => {
            const userStatus = store.getters['user/userStatus'];
            if (userStatus === 'admin') {
              next();
            } else if (userStatus === 'guest') {
              next('/dashboard');
            } else {
              next('/');
            }
          });
        },
      },
      {
        path: '/admin/user_create',
        name: 'user_create',
        component: UserCreate,
        beforeEnter: (to, from, next) => {
          store.dispatch('user/adminCheck').then(() => {
            const userStatus = store.getters['user/userStatus'];
            if (userStatus === 'admin') {
              next();
            } else if (userStatus === 'guest') {
              next('/dashboard');
            } else {
              next('/');
            }
          });
        },
      },
      {
        path: '/upload/option',
        name: 'Upload-option',
        component: UploadOption
      },
      {
        path: '/cms-setting',
        name: 'PlayerOption',
        component: PlayerOption
      },
      {
        path: '/admin/encodingservers_list',
        name: 'encodingservers_list',
        component: EncodingList
      },
      {
        path: '/admin/encodingservers_create',
        name: 'encodingservers_create',
        component: EncodingCreate
      },
      {
        path: '/template',
        name: 'template',
        component: Template
      },
      {
        path: '/cdn',
        name: 'cdn',
        component: CdnList,
      },
      {
        path: '/cdn/info',
        name: 'cdn_info',
        component: CdnInfo,
      },
      {
        path: '/cdn/create_wowzaserver',
        name: 'cdncreate_wowzaserver',
        component: CdnCreate
      },
      {
        path: '/cert/cert_list',
        name: 'cert_list',
        component: CertList
      },
      {
        path: '/cert/cert_import',
        name: 'cert_list_import',
        component: CertImport
      },
      {
        path: '/cert/cert_tags',
        name: 'cert_tags',
        component: CertTag
      },
      {
        path: '/wowza/wowzaservers_list',
        name: 'wowzaservers_list',
        component: WowzaList
      },
      {
        path: '/wowza/wowzaservers_create',
        name: 'wowzaservers_create',
        component: WowzaCreate
      },
      {
        path: '/wowzastream/wowzalivestream_create',
        name: 'wowzalivestream_create',
        component: WowzaLivestreamCreate
      },
      {
        path: '/wowzastream/wowzalivestream_recording',
        name: 'wowzalivestream_recording',
        component: WowzaLivestreamRecording
      },
      {
        path: '/wowzastream/wowzalivestream_view/:uuid',
        name: 'wowzalivestream_view',
        component: WowzaLivestreamView
      },
      {
        path: '/wowzastream/wowzalivepullstream_view/:uuid',
        name: 'wowzalivepullstream_view',
        component: WowzaLivePullstreamView
      },
      {
        path: '/live-statistics',
        name: 'livestatistics',
        component: LiveStatistics
      },
      {
        path: '/vod-statistics',
        name: 'vodstatistics',
        component: VodStatistics
      },
      {
        path: '/social-upload',
        name: 'socialupload',
        component: SocialUpload,
      },
      // {
      //   path: '/social/connect',
      //   name: 'socialConnect',
      //   component: () => import('../views/social/SocialConnect.vue')
      // },
      {
        path: '/social-Connected',
        name: 'socialConnected',
        component: socialConnected,
      },
      {
        path: '/settings/social',
        name: 'settingsSocial',
        component: socialConnected,
      },
      {
        path: '/password/reset',
        beforeEnter(to, from, next) {
          if (!to.query.token || !to.query.email) {
            next('/');
          } else {
            next('/password/reset/' + to.query.token);
          }
        },
        meta: { public: true },
      },
      {
        path: '/password/reset/:token',
        name: 'passwordreset',
        component: PasswordReset,
        meta: { public: true },
      },
      {
        path: '/auth/callback',
        name: 'GoogleCallback',
        component: GoogleCallback,
        meta: { public: true },
      },
      {
        path: '/webrtc-statistics',
        name: 'webRtcStatistics',
        component: WebRtcStatistics
      },
      {
        path: '/webrtc/stream_create',
        name: 'webrtclivestream_create',
        component: WebRtcLivestreamCreate
      },
      {
        path: '/webrtc/stream_recording',
        name: 'webrtclivestream_recording',
        component: WebRtcLivestreamRecording
      },
      {
        path: '/webrtc/stream_view/:uuid',
        name: 'webrtclivestream_view',
        component: WebRtcLivestreamView
      },
      {
        path: '/webrtc/wowzalivepullstream_view/:uuid',
        name: 'webrtclivepullstream_view',
        component: WebRtcLivePullstreamView
      },
    ]
  },
  {
    path: '/vod-manual',
    name: 'vod-manual',
    component: () => import('../views/manual/Vod_Manual.vue'),
    meta: { public: true },
  },
  {
    path: '/live-manual',
    name: 'live-manual',
    component: () => import('../views/manual/LiveManual.vue'),
    meta: { public: true },
  },
  {
    path: '/live-webrtc-manual',
    name: 'live-webrtc-manual',
    component: () => import('../views/manual/WebRTCManual.vue'),
    meta: { public: true },
  },
  {
    path: '/404',
    name: '404pages',
    component: PAGE404,
    meta: { public: true },
  },
  {
    path: '/mediaerror',
    name: 'PAGEMedia',
    component: PAGEMedia,
    meta: { public: true },
  },
  // {
  //   path: '/password/reset',
  //   beforeEnter(to, from, next) {
  //     if (!to.query.token || !to.query.email) {
  //       next('/');
  //     } else {
  //       next('/password/reset/' + to.query.token);
  //     }
  //   }
  // },
  {
    path: '/player',
    name: 'player',
    //component: PlayerStyle,
    component: Player,
    meta: { public: true },
  },
  // {
  //   path: '/playtest',
  //   name: 'player',
  //   //component: PlayerStyle,
  //   component: Playertest,
  // },
  {
    path: '/play',
    name: 'Play',
    component: Play,
    meta: { public: true },
  },
  {
    path: '/webrtcPlayer',
    name: 'webrtcPlayer',
    component: webrtcPlayer,
    meta: { public: true },
  },
  {
    path: '/securePlayer',
    name: 'securePlayer',
    component: securePlayer,
    meta: { public: true },
  },
  {
    path: '/streamPlayer',
    name: 'streamPlayer',
    component: streamPlayer,
    meta: { public: true },
  },
  {
    path: '/403',
    name: 'forbidden',
    component: ForbiddenPage,
    meta: { public: true },
  },
  {
    path: '*',
    redirect: '/'
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const requiresAuth = (to) => !to.matched.some(record => record.meta && record.meta.public);

router.beforeEach(async (to, from, next) => {
  store.dispatch('search/resetSearch');

  if (to.name === 'Login') {
    await store.dispatch('user/checkAuth');
    const isLoggedIn = store.getters['user/isLoggedIn'];
    if (isLoggedIn) {
      return next('/dashboard');
    }
    return next();
  }

  if (!requiresAuth(to)) {
    return next();
  }

  await store.dispatch('user/checkAuth');
  const isLoggedIn = store.getters['user/isLoggedIn'];

  if (!isLoggedIn) {
    return next('/');
  }

  if (!store.state.naviList.items.length || !store.state.naviList.allowInitialized) {
    await store.dispatch('naviList/list');
  }

  const requiredPermissions = Array.isArray(to.meta?.requiredPermissions)
    ? to.meta.requiredPermissions
    : [];

  if (requiredPermissions.length) {
    const permissionMap = store.getters['naviList/permissionMap'] || {};
    const missingPermission = requiredPermissions.find(key => !permissionMap[key]);
    if (missingPermission) {
      return next({ name: 'forbidden' });
    }
  }

  if (to && to.name === 'asset') {
    store.dispatch('asset/updateDrawer', false);
  }

  next();
});

export default router
